import React from "react";
import { Box } from "@mui/system";
import useMakeScrollable from "custom_hooks/make-scrollable";
import { useSurveyDetail } from "./QuestionFlow/QuestionContext";
import { MultipleChoiceComponent } from "./MultipleChoiceComponent";
import { SingleChoiceComponent } from "./SingleChoiceComponent";
import { FreeTextComponent } from "./FreeTextComponent";
import { NumberInput } from "./NumberInput";
import { Range } from "./Range";
import EmptyHint from "components/home/empty-hint";
import SurveyList from "./SurveyList";

const QuestionWrapper = ({ children, name }) => {
  useMakeScrollable();
  const { questions, currentIndex } = useSurveyDetail();
  const currentQuestion = questions[currentIndex];

  if(!currentQuestion) return null;
  return (
      <div className="scrollable">
          <div className="survey-info" style={{paddingBottom: "120px"}}>
            <div className="survey-title">{name}</div>
              <div className="survey-question">{currentQuestion.text}</div>
              {children}
          </div>
      </div>
  );
};

const getInputByType = (type) => {
  switch (type) {
    case "TextQuestion":
      return ({ question, addAnswer, next, previous, initialValues,loadingAnswer }) => (
        <FreeTextComponent
          question={question}
          addAnswer={addAnswer}
          next={next}
          previous={previous}
          initialValues={initialValues}
          loadingAnswer={loadingAnswer}
        />
      );
    case "MultiSelectQuestion":
      return ({
        question,
        addAnswer,
        next,
        previous,
        options,
        initialValues,
        loadingAnswer
      }) => (
        <MultipleChoiceComponent
          question={question}
          addAnswer={addAnswer}
          next={next}
          previous={previous}
          initialValues={initialValues}
          options={options}
          loadingAnswer={loadingAnswer}
        />
      );
    case "SingleSelectQuestion":
      return ({
        question,
        addAnswer,
        next,
        previous,
        options,
        initialValues,
        loadingAnswer
      }) => (
        <SingleChoiceComponent
          question={question}
          addAnswer={addAnswer}
          next={next}
          previous={previous}
          initialValues={initialValues}
          options={options}
          loadingAnswer={loadingAnswer}
        />
      );
    case "numberInput":
      return ({
        question,
        addAnswer,
        next,
        previous,
        options,
        initialValues,
      }) => (
        <NumberInput
          question={question}
          addAnswer={addAnswer}
          next={next}
          previous={previous}
          initialValues={initialValues}
          options={options}
        />
      );
    case "range":
      return ({
        question,
        addAnswer,
        next,
        previous,
        options,
        initialValues,
      }) => (
        <Range
          question={question}
          addAnswer={addAnswer}
          next={next}
          previous={previous}
          initialValues={initialValues}
          options={options}
        />
      );
    default:
      return () => null;
  }
};

function SurveyQuestion({name}) {
  const {
    questions,
    currentIndex,
    next,
    previous,
    addAnswer,
    loadingAnswer,
  } = useSurveyDetail();

  const currentQuestion = questions[currentIndex];
  if(!currentQuestion) return <div className="scrollable"><EmptyHint route="/surveys-list/" /></div>;
  
 
  const InputComponent:any = getInputByType(currentQuestion?.questionType);
  const mapToOptions = (initialValues, options) => {
    return options.filter((each) => {
      const exists = initialValues.find(
        (eachValue) => eachValue?.answerText === each?.text
      );
      return !!exists;
    });
  };

  
  return (
    <QuestionWrapper name={name}>
      {currentQuestion ? <InputComponent
        initialValues={
          currentQuestion?.questionType !== "MultiSelectQuestion"
            ? (currentQuestion?.user_answers ? currentQuestion?.user_answers[0]: {} )
            : mapToOptions(
                currentQuestion?.user_answers ??[],
                currentQuestion?.answerOptions
              )
        }
        next={() => next()}
        previous={previous}
        addAnswer={addAnswer}
        question={currentQuestion}
        options={currentQuestion?.answerOptions}
        loadingAnswer={loadingAnswer}
      /> : <SurveyList />}
    </QuestionWrapper>
  );
}

export default SurveyQuestion;
